import useSWR from "swr";
import {Utils} from "@/common/utils";
import { StandardResponse } from "@/types/swr";
import { Ticket } from "Stores/dashboardStore/tickets";
const clientConfigs = Utils.getEAIClientConfigs();

export type DueAndUpcomingActionPlan = {
    as_due_type: string
    count: number
}

export type DueAndUpcomingActionPlansResponse = {
    data: DueAndUpcomingActionPlan[]
}

export function useDueAndUpcomingActionPlans(actionPlanFilter = "myItems") {
    const {data, error, isLoading, mutate} = useSWR<DueAndUpcomingActionPlansResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/actionplans/due-and-upcoming?filter=${actionPlanFilter}`);

    return {
        data: data ? data.data.sort((a, b) => a.as_due_type === "overdue" ? -1 : b.as_due_type === "overdue" ? 1 : a.as_due_type.localeCompare(b.as_due_type)) : undefined,
        error,
        isLoading,
        mutate
    };
}

export type ActionPlanFilters = {
    strategicPlanOnly: boolean
    pageSize?: number
    pageNumber?: number
    queryFilter?: string | null
    queryByFilter?: string | null
    statusFilter?: string | null
    sortFilter?: string | null
    sortOrderFilter?: string | null
    createdEndFilter?: string | null
    createdStartFilter?: string | null
    evaluationEndFilter?: string | null
    evaluationStartFilter?: string | null
}

export function useActionPlans(
    {
        strategicPlanOnly,
        pageSize,
        pageNumber,
        queryFilter,
        queryByFilter,
        statusFilter,
        createdStartFilter,
        createdEndFilter,
        evaluationStartFilter,
        evaluationEndFilter,
        sortFilter,
        sortOrderFilter,
    }: ActionPlanFilters, fetch = true) {
    // build query params
    const params = new URLSearchParams();
    params.append("fields", "all");
    if (strategicPlanOnly) {
        params.append("strategicPlanOnly", "true");
    }
    if (pageSize) params.append("page_size", pageSize.toString());
    if (pageNumber) {
        params.append("page", pageNumber.toString());
    }

    if (queryFilter) {
        params.append("search_query", queryFilter);
    }
    if (queryByFilter) {
        params.append("search_by", queryByFilter);
    }
    if (statusFilter) {
        params.append("status", statusFilter);
    }

    if (sortFilter) {
        params.append("order_by", sortFilter);
    }
    if (sortOrderFilter) {
        params.append("order_by_direction", sortOrderFilter);
    }

    if (createdStartFilter) {
        params.append("created_start", createdStartFilter);
    }
    if (createdEndFilter) {
        params.append("created_end", createdEndFilter);
    }
    if (evaluationStartFilter) {
        params.append("evaluation_date_start", evaluationStartFilter);
    }
    if (evaluationEndFilter) {
        params.append("evaluation_date_end", evaluationEndFilter);
    }

    const queryString = params.toString();
    const {data, error, isLoading, mutate} = useSWR<StandardResponse<Ticket[]>, Error>(fetch ? `${clientConfigs.baseUrl}/actionplans?${queryString}` : null);

    return {
        data: data,
        error,
        isLoading,
        mutate
    };
}
